import { DialogObject } from '../../../../components/dialog/dialog.types';

interface getPaaConfirmWorkflowObjectProps {
  action: () => void;
  toggleVisiblity?: () => void;
}

export const getPaaConfirmWorkflowObject = ({ action, toggleVisiblity }: getPaaConfirmWorkflowObjectProps): DialogObject => {
  return {
    title: `Confirmation de passage pour validation`,
    description: 'Ce PAA sera passé pour validation, veuillez confirmer les modifications avant de continuer',
    actions: [
      {
        label: 'Passer pour validation',
        variant: 'info',
        onClick: () => action?.(),
      },
      {
        label: 'Annuler',
        onClick: () => {
          toggleVisiblity?.();
        },
        variant: 'secondary',
      },
    ],
  };
};
